import { Skeleton as ArcSkeleton, Box } from '@cad-arc';

interface SkeletonProps {
    height: string | undefined;
    width: string | undefined;
    margin: string | undefined;
}

const BaseSkeleton: React.FC<SkeletonProps> = ({ height, width, margin }) => (
    <Box m={margin} w={width}>
        <ArcSkeleton>
            <Box h={height} />
        </ArcSkeleton>
    </Box>
);

export const SkeletonTitle: React.FC<{ width?: string }> = ({ width }) => (
    <BaseSkeleton height="26px" margin="0 0 8px 0" width={width ?? '25%'} />
);

export const SkeletonText: React.FC<{ width?: string }> = ({ width }) => (
    <BaseSkeleton height="18px" margin="0 0 8px 0" width={width ?? '25%'} />
);

export const Skeleton: React.FC = () => (
    <BaseSkeleton height="100px" margin="0 0 12px 0" width="100%" />
);

export const SkeletonButton: React.FC = () => (
    <BaseSkeleton height="var(--arc-sizes-control-md)" width="56px" margin="0 4px 0 4px" />
);
